import { InjectionToken } from '@angular/core';
import { ModalPageScrollStrategy } from './modal-page-scroll-strategy';
import type { RendererFactory2 } from '@angular/core';
import type { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';

import type { ModalOptions } from './modal-options';

export type ScrollStrategyFunc = (modalOptions: ModalOptions) => ScrollStrategy;
/** Injection token for the modal's ScrollStrategy. */
export const MODAL_SCROLL_STRATEGY_FACTORY = new InjectionToken<() => ScrollStrategy>('modalScrollStrategy');

export const MODAL_SCROLL_STRATEGY_PROVIDER_FACTORY = (document: Document,
                                                       window: Window,
                                                       rendererFactory: RendererFactory2,
                                                       scrollStrategyOptions: ScrollStrategyOptions): ScrollStrategyFunc => (modalOptions: ModalOptions): ScrollStrategy => {
  if (modalOptions?.pageScrollBehavior === 'block') {
    return scrollStrategyOptions.block();
  }
  return new ModalPageScrollStrategy(document, window, rendererFactory, modalOptions, scrollStrategyOptions);
};
